import React, { useState, useEffect } from 'react'
import { Box, Flex, Link } from 'theme-ui'
import { default as NextLink } from 'next/link'
import Monogram from './monogram'
import Row from './row'
import Column from './column'

const Footer = () => {
  const [year, setYear] = useState<number | null>(null)
  useEffect(() => {
    setYear(new Date().getFullYear())
  }, [])

  return (
    <Box
      sx={{
        mt: [7, 7, 7, 8],
        mb: [7, 7, 7, 8],
        pb: [2, 1, 0, 0],
      }}
    >
      <Row sx={{ mb: [0, 0, 4, 5] }}>
        <Column start={[1, 2]} width={[3, 3]}>
          <Box>
            <Box
              sx={{
                fontSize: [2, 2, 2, 3],
                fontFamily: 'heading',
                letterSpacing: 'mono',
                mb: [2],
              }}
            >
              EMAIL
            </Box>
            <Link
              href='mailto:hello@carbonplan.org'
              sx={{
                textDecoration: 'none',
                fontSize: [2, 2, 2, 3],
              }}
            >
              hello@carbonplan.org
            </Link>
          </Box>
        </Column>
        <Column
          start={[5]}
          width={[1]}
          dl={1}
          dr={1}
          sx={{
            display: ['flex', 'none', 'none', 'none'],
            justifyContent: ['center'],
          }}
        >
          <Monogram sx={{ mt: ['-4px'], width: '60px', height: '60px' }} />
        </Column>
        <Column start={[1, 5, 5, 5]} width={[3, 3]} sx={{ mt: [3, 0, 0, 0] }}>
          <Box>
            <Box
              sx={{
                fontSize: [2, 2, 2, 3],
                fontFamily: 'heading',
                letterSpacing: 'mono',
                mb: [2],
              }}
            >
              NEWSLETTER
            </Box>
            <Link
              href='https://carbonplan.org/newsletter'
              sx={{
                textDecoration: 'none',
                fontSize: [2, 2, 2, 3],
              }}
            >
              Subscribe
            </Link>
          </Box>
        </Column>
        <Column
          start={[1, 9]}
          width={[5, 4, 3, 3]}
          sx={{ mt: ['42px', '42px', 0, 0], mb: [3, 3, 0, 0] }}
        >
          <Box>
            <Box
              sx={{
                fontSize: [2, 2, 2, 3],
                fontFamily: 'body',
                color: 'secondary',
              }}
            >
              CarbonPlan is a registered nonprofit public benefit corporation in
              California with 501(c)(3) status.
            </Box>
          </Box>
        </Column>
      </Row>
      <Row sx={{ mb: ['2px'], mt: [5, 5, 4] }}>
        <Column
          start={[1, 1, 2, 2]}
          width={[3, 2, 3, 3]}
          sx={{
            display: 'flex',
            alignItems: ['flex-start', 'flex-start', 'flex-end'],
          }}
        >
          <Box
            sx={{
              bottom: '0px',
              borderStyle: 'solid',
              borderColor: 'muted',
              borderWidth: '0px',
              borderTopWidth: '1px',
              display: 'inline-block',
              pt: [2],
            }}
          >
            <Box
              sx={{
                color: 'secondary',
                fontSize: [1, 1, 1, 2],
                fontFamily: 'mono',
                letterSpacing: 'mono',
              }}
            >
              <Flex
                sx={{
                  flexDirection: ['column', 'column', 'row', 'row'],
                  gap: [0, 0, '10px', '12px'],
                }}
              >
                <Box>(c) {year}</Box>
                <Box>CARBONPLAN</Box>
              </Flex>
            </Box>
          </Box>
        </Column>
        <Column
          start={[4, 3, 5, 5]}
          width={[3, 3, 4, 4]}
          sx={{
            display: 'flex',
            alignItems: ['flex-start', 'flex-start', 'flex-end'],
            mt: [0, 0, 0, 0],
          }}
        >
          <Box
            sx={{
              bottom: '0px',
              borderStyle: 'solid',
              borderColor: 'muted',
              borderWidth: '0px',
              borderTopWidth: '1px',
              pt: [2],
            }}
          >
            <Flex
              sx={{
                color: 'secondary',
                fontSize: [1, 1, 1, 2],
                fontFamily: 'mono',
                letterSpacing: 'mono',
                flexDirection: ['column', 'column', 'row', 'row'],
                gap: [0, 0, '10px', '12px'],
              }}
            >
              <NextLink href='/terms' passHref legacyBehavior>
                <Box
                  as='a'
                  sx={{
                    color: 'secondary',
                    '&:hover': {
                      color: 'primary',
                    },
                  }}
                >
                  TERMS OF USE
                </Box>
              </NextLink>
              <Box sx={{ display: ['none', 'none', 'initial', 'initial'] }}>
                {' / '}
              </Box>
              <NextLink href='/privacy' passHref legacyBehavior>
                <Box
                  as='a'
                  sx={{
                    color: 'secondary',
                    '&:hover': {
                      color: 'primary',
                    },
                  }}
                >
                  PRIVACY POLICY
                </Box>
              </NextLink>
            </Flex>
          </Box>
        </Column>
        <Column
          start={[5, 7, 9, 9]}
          width={[2, 2, 3, 3]}
          sx={{ display: ['none', 'initial', 'initial', 'initial'] }}
        >
          <Monogram
            sx={{
              width: 80,
              height: 80,
              mt: [0, '-10px', 4, 5],
              mb: ['-12px'],
            }}
          />
        </Column>
      </Row>
    </Box>
  )
}

export default Footer
